import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Popup } from '../../utils/popups';
import { Button } from '../Button';
import { AbstractPopup, DismissalReason } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
function ConfirmationPopup({ title = 'Are you sure?', message = "It's a one-way ticket—no refunds.", okLabel = 'Yes', cancelLabel = 'No', reject, resolve, }) {
    return (_jsxs(ConfirmationPopupRoot, { reject: reject, children: [_jsx("h2", { children: title }), _jsx(Message, { children: message }), _jsxs(Buttons, { children: [_jsx(Button, { type: "button", kind: "secondary", size: "mini", onClick: () => {
                            reject(DismissalReason.CloseButton);
                        }, children: cancelLabel }), _jsx(Button, { type: "button", kind: "primary", variant: "destructive-inverted", size: "mini", onClick: () => {
                            resolve();
                        }, children: okLabel })] })] }));
}
const Buttons = styled.div `
    display: grid;
    gap: 1rem;

    @media (min-width: 22rem) {
        grid-template-columns: 1fr 1fr;
    }
`;
const Message = styled.div `
    margin: 1rem 0 1.5rem;
    font-size: 1.125rem;
    line-height: 1.5rem;
`;
const ConfirmationPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1.5rem;
    --Popup_Width: 23.75rem;

    text-align: center;

    h2 {
        font-size: 1.375rem;
        font-weight: 600;
        line-height: 1.5em;
    }
`;
const confirmationPopup = Popup.create(ConfirmationPopup);
export async function confirm(payload = {}) {
    try {
        await confirmationPopup.pop(payload);
        return true;
    }
    catch (_) { }
    return false;
}
